import * as React from "react";
import axios from "axios";

import { useProvider } from "../../Context";
import useAuth from "./useAuth";
import qs from "qs";

const client = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
});
client.interceptors.request.use((config) => {
  config.paramsSerializer = (params) =>
    qs.stringify(params, { allowDots: true });
  return config;
});
const initialState = {
  isFetch: false,
};

function reducer(state, { type, payload }) {
  switch (type) {
    case "set":
      return { ...state, ...payload };
    default:
      throw new Error("Action type not found");
  }
}

export function useApiReducer() {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  return {
    state,
    dispatch,
  };
}

export default function useRequest() {
  const {
    api: { state, dispatch },
  } = useProvider();
  const {
    state: { token, user },
  } = useAuth();
  const auth = useAuth();

  async function request(config, options = {}) {
    const url = config.url.replace(":account_id", user.account_id);
    const reqConfig = {
      url: url,
      method: config.method,
      headers: config.headers || {},
      responseType: config.responseType || {},
      data: config.data,
    };
    reqConfig.headers.Authorization = `Bearer ${token}`;
    dispatch({
      type: "set",
      payload: {
        isFetch: true,
      },
    });
    try {
      const result = await client(reqConfig);
      dispatch({
        type: "set",
        payload: {
          isFetch: false,
        },
      });
      return result;
    } catch (errors) {
      console.error("request err", errors);
      console.error("error response", errors.response);
      console.error("request config", reqConfig);
      dispatch({
        type: "set",
        payload: {
          isFetch: false,
        },
      });

      switch (errors.response.status) {
        case 401:
          auth.logout();
          window.location = '/upload/?status=401';
          break;
        case 404:
          auth.logout();
          window.location = '/upload/?status=404';
          break;
        default:
          break;
      }
      throw errors;
    }
  }

  function convertQueryParam(params) {
    return qs.stringify(params).replace(/%5B\d%5D/g, "%5B%5D");
  }

  return { state, dispatch, request, convertQueryParam };
}
